import { useState } from "react";
import PhoneInput from "../phoneInput/PhoneInput";
import OtpInput from "../otpInput/OtpInput";
import EmailInput from "../EmailInput/EmailInput";

const InputSlider = ({ setIsVisible, bookPage, setBookPage }) => {
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [getOtpClicked, setGetOtpClicked] = useState(false);
  const [SignupPage, setSignupPage] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [emailClicked, setEmailClicked] = useState(false);
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [accessToken, setAccessToken] = useState("");

  return (
    <>
      <div className="heading-8">Login to Hightable</div>
      <div className="container">
        <div className={`phone-input ${getOtpClicked ? "slide-out" : ""}`}>
          <PhoneInput
            setGetOtpCliked={setGetOtpClicked}
            phone={phone}
            setPhone={setPhone}
            setSignupPage={setSignupPage}
            SignupPage={SignupPage}
            showModal={showModal}
            setShowModal={setShowModal}
            setEmailClicked={setEmailClicked}
            setIsVisible={setIsVisible}
            setGetOtpClicked={setGetOtpClicked}
            setAccessToken= {setAccessToken}
          />
        </div>
        <div className={`slide otp-input ${emailClicked ? "slide-in" : ""}`}>
          <EmailInput
            email={email}
            setEmail={setEmail}
            name={name}
            setName={setName}
            lastName={lastName}
            setLastName={setLastName}
            setIsVisible={setIsVisible}
            setBookPage={setBookPage}
            bookPage={bookPage}
            age={age}
            setAge={setAge}
            gender={gender}
            setGender={setGender}
            accessToken={accessToken}
          />
        </div>
        <div className={`slide otp-input ${getOtpClicked ? "slide-in" : ""}`}>
            <OtpInput
              phone={phone}
              setIsVisible={setIsVisible}
              SignupPage={SignupPage}
              setBookPage={setBookPage}
              bookPage={bookPage}
            />
          </div>
      </div>
    </>
  );
};

export default InputSlider;
